import React from 'react';
import PropTypes from 'prop-types';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

const SrTourArchiveNote = ({ tour }) => {
  const archivedDate = momentWithAustinTimezone(tour.lastStatusUpdateDate);

  return (
    <div>
      {tour.lastStatusUpdateDate && (
        <div>
          <span className="tourDate">
            Archived {archivedDate.format('MMM Do')} at {archivedDate.format('h:mm A')}
          </span>
        </div>
      )}
      {tour.cancelNote && (
        <div className="tourCancelNote">
          <span>"{tour.cancelNote}"</span>
        </div>
      )}
    </div>
  );
};

SrTourArchiveNote.propTypes = {
  tour: PropTypes.object.isRequired,
};

SrTourArchiveNote.displayName = 'SrTourArchiveNote';

export default SrTourArchiveNote;
